import { getTranslationValueByKey } from "./index";

export const getStreetOptions = ({ cities, city, area }) => {
  if (!city) return [];

  const cityKey = city?.name ? city.name : city;
  const cityData = cities?.[cityKey];
  if (!cityData) return [];

  const areasArray = cityData.areas || cityData.areasAndStreets || [];
  const foundArea = areasArray.find(
    (location) => location.name === area || location.area === area
  );
  if (!foundArea) return [];

  return (foundArea.streets || []).map((street) => ({
    id: street.name,
    label: street.name,
  }));
};

const findFilterByTypeKey = (filters, typeKey) => {
  return filters?.find((f) => f.type_key === typeKey);
};

const getOptionsFromFilter = (filter) => {
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    value: opt.option_value,
    label: opt.option_value,
  }));
};

export const buildTypeAndSubTypeOptions = ({ filters, translations, lang }) => {
  const mainCategories = (filters || []).filter((f) => f.is_main_category);

  const filt = mainCategories.map((category) => ({
    id: category.type_key,
    value: translations?.[category.type_key]?.[lang] || category.type_name,
  }));

  const subFilters = mainCategories.reduce((acc, category) => {
    acc[category.type_key] = (category.subtypes || []).map((subtype) => ({
      id: subtype.sub_type_name,
      value:
        translations?.[subtype.sub_type_key]?.[lang] || subtype.sub_type_name,
    }));
    return acc;
  }, {});

  return { filt, subFilters };
};

export const getRoomNumberOptions = (filters) => {
  const roomFilter = findFilterByTypeKey(filters, "form_input_rooms_number");
  return getOptionsFromFilter(roomFilter);
};

export const getFacilitiesOptions = ({
  moreFilters,
  translations,
  lang,
  name = "form_input_property_accompanying_facilities",
}) => {
  const filter = findFilterByTypeKey(moreFilters, name);
  if (!filter?.options) return [{ id: "", label: "" }];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};

const removeDuplicates = (arr, prop) => {
  const seen = {};
  return arr.filter((obj) => {
    const value = obj[prop];
    return seen.hasOwnProperty(value) ? false : (seen[value] = true);
  });
};

export const getFloorsOptions = ({ translations, lang, floorOptions }) => {
  const arr = [];

  arr.push({
    id: 0,
    label: translations?.["form_input_property_ground_floor"]?.[lang] || "",
  });

  (floorOptions || []).forEach((floor) => {
    if (floor === 15) {
      arr.push({ label: "15.+ sprat", id: 15 });
      return;
    }

    const key = getTranslationValueByKey(floor, floor);
    arr.push({
      label: translations?.[key]?.[lang] || "",
      id: floor,
    });
  });

  return removeDuplicates(arr, "id");
};

export const getHeatingModeOptions = ({ moreFilters, translations, lang }) => {
  const filter = findFilterByTypeKey(
    moreFilters,
    "form_input_property_heating_mode"
  );
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};

export const getAccompanyingOptions = ({ moreFilters, translations, lang }) => {
  const filter = findFilterByTypeKey(
    moreFilters,
    "form_input_property_accompanying_facilities"
  );
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};

export const getHeatingModeTypeOptions = ({
  moreFilters,
  translations,
  lang,
}) => {
  const filter = findFilterByTypeKey(
    moreFilters,
    "form_input_property_fuel_type"
  );
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};

export const getLotTechnicalOptions = ({ moreFilters, translations, lang }) => {
  const filter = moreFilters?.find(
    (f) => f.type_key === "form_input_lot" && !f.is_main_category,
  );
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};

export const getBathroomsOptions = ({ moreFilters }) => {
  const filter = findFilterByTypeKey(moreFilters, "bathrooms");
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: opt.option_value,
  }));
};

export const getAssistOptions = ({ moreFilters, translations, lang }) => {
  const filter = findFilterByTypeKey(moreFilters, "form_input_property_assist");
  if (!filter?.options) return [];
  return filter.options.map((opt) => ({
    id: opt.option_value,
    label: translations?.[opt.option_key]?.[lang] || opt.option_value,
  }));
};
